module.exports = __webpack_public_path__ + "static/media/l_itdot_7.9d08d361.png";